import React from "react";
import ClientAppSidebar from "../../../../components/ClientAppSidebar";
import {
  LastMonthRevenueReviewSection,
  RevenueThisMonthSection,
  KeyMetricsRevenueSection,
  TwelveMonthRevenueTrendSection,
  RevenueConcentrationSection,
  ReceivablesAgingSection,
  RecentRevenueActivitySection,
} from "../components/revenue_components";
import { useRevenueBootstrap } from "../hooks/useRevenueBootstrap";

/**
 * Revenue page: one bootstrap request for core metrics; AI insights still load per section.
 */
export default function RevenuePage() {
  useRevenueBootstrap();

  return (
    <div className="flex w-full items-start h-screen">
      <ClientAppSidebar />
      <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 self-stretch bg-default-background overflow-y-auto">
        <div className="container max-w-none flex w-full min-w-0 grow shrink-0 basis-0 items-start gap-8 bg-neutral-50 py-12 overflow-auto">
          <div className="flex min-w-0 grow shrink-0 basis-0 flex-col items-start gap-8 w-full max-w-full">
            <div className="flex w-full items-center justify-between">
              <span className="text-heading-1 font-heading-1 text-default-font">
                Revenue
              </span>
            </div>
            <RevenueThisMonthSection />
            <LastMonthRevenueReviewSection />

            <KeyMetricsRevenueSection />

            <TwelveMonthRevenueTrendSection />

            <div className="grid min-h-0 w-full grid-cols-2 gap-8 items-stretch">
              <RevenueConcentrationSection />
              <ReceivablesAgingSection />
            </div>

            <RecentRevenueActivitySection />
          </div>
        </div>
      </div>
    </div>
  );
}
